import { Outlet, createRootRoute } from '@tanstack/react-router';
import '../styles/smash.css';

export const Route = createRootRoute({
  component: () => (
    <main>
      <Outlet />
    </main>
  ),
});
